import { IAppSettings } from './types/app-settings.type';

export const appSettings: IAppSettings = window['appSettings'];
